var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9029_1995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.15681 0 0 7.156 0 16C0 24.8431 7.156 32 16 32C24.8432 32 32 24.844 32 16C32 7.15681 24.844 0 16 0ZM15.5266 23.4887C14.6209 23.4887 13.9259 22.7305 13.9259 21.8669C13.9259 20.9824 14.642 20.2453 15.5266 20.2453C16.4112 20.2453 17.1482 20.9824 17.1482 21.867C17.1482 22.7304 16.4321 23.4887 15.5266 23.4887ZM17.9274 15.296C16.7691 16.2016 16.748 16.8334 16.748 17.9286C16.748 18.3288 16.5374 18.7921 15.5054 18.7921C14.6419 18.7921 14.3471 18.4762 14.3471 17.3811C14.3471 15.5698 15.1474 14.7063 15.7582 14.1798C16.4532 13.5901 17.6326 12.9373 17.6326 11.8C17.6326 10.8311 16.7902 10.3678 15.7371 10.3678C13.5889 10.3678 14.0523 11.9896 12.9149 11.9896C12.3463 11.9896 11.6513 11.6104 11.6513 10.7891C11.6513 9.65181 12.9571 7.96688 15.8003 7.96688C18.4961 7.96688 20.2862 9.46225 20.2862 11.4419C20.2862 13.4216 18.4961 14.8537 17.9274 15.296Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9029_1995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpActive);
export default __webpack_public_path__ + "static/media/Help-Active.e90886e3c2c28f2141b94c76505e345f.svg";
export { ForwardRef as ReactComponent };